import userReducer from '@app/store/slices/userSlice';
import authReducer from '@app/store/slices/authSlice';
import nightModeReducer from '@app/store/slices/nightModeSlice';
import themeReducer from '@app/store/slices/themeSlice';
import pwaReducer from '@app/store/slices/pwaSlice';
import manualReducer from '@app/store/slices/manualSlice';
import formReducer from '@app/store/slices/formSlice';
import generalReducer from '@app/store/slices/generalSlice';
import submissionReducer from '@app/store/slices/submissionSlice';
import couponReducer from '@app/store/slices/couponSlice';
import modelReducer from '@app/store/slices/modelSlice';

export default {
  user: userReducer,
  auth: authReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
  manual: manualReducer,
  form: formReducer,
  general: generalReducer,
  submission: submissionReducer,
  coupon: couponReducer,
  model: modelReducer,
};
